<template>
  <div class="view-tasklists assessment-add-section">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu />
        <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <div class="col-6 padding-lr-5 float-left" style="padding-left: 0;padding-top: 5px;">
              <h3 class="d-inline heading"><div class="float-left" style="padding-top: 2px;">Edit Assessment: {{ assessment_section_obj.assessment.name }} </div><div class="float-left" style="padding-top: 2px;"><i v-on:click="isEditModalVisible = true, verrors.clear()" class="cursor-pointer assessment-edit-icon fa fa-pencil-square-o" aria-hidden="true" ></i></div></h3>
            </div>
            <div class="col-2 float-left padding-lr-5">
              <div class="search-padd" id="mentee-group-wrapper">
              <multiselect
                v-model="roles_selected"
                :options="roles_options"
                track-by="name" label="name"
                placeholder="Select Users..."
                :multiple="true" 
                :close-on-select="false"
                :show-labels="false"
                name="roles_show"
                id="roles_show"
                >
                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
          

              </multiselect>

              </div>
            </div>

            <div class="col-2 float-left padding-lr-5">
              <div class="search-padd" id="mentee-group-wrapper">
              <multiselect
                v-model="affiliate_selected"
                :options="affiliate_options" track-by="name" label="name"
                placeholder="Select Affiliates..." :multiple="true"  :close-on-select="false" :show-labels="false"
                name="affiliate_show"
                id="affiliate_show"
                >
                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
              </multiselect>
              </div>
            </div>
            <div class="col-lg-2 padding-lr-5 float-right text-align-right" style="padding-right: 0;">
              <button
                v-on:click="addSectionClick()"
                class="btn btn-white col-9 override-padding" style="height: 30px; border-radius: 10px; font-weight: bold;"
                >Add Section</button>
            </div>

          </div>
          <div style="clear: both"></div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>

          <div class="col-12 override-padding assessment-intro" style="margin-top: 15px;">
            <div class="heading-row col-12 override-padding" style="border: 0; padding-top: 10px;">
              <div class="col-9 float-left override-padding">Assessment Introduction / Landing Page
              </div>
              <div class="col-3 float-left override-padding">Intro Auto-Fill Assets
              </div>
            </div>
            <div class="col-12 override-padding" style="">
              <div class="col-9 float-left override-padding" style="padding-right: 15px; margin-bottom: 10px; padding-bottom: 30px; height: 250px; ">
                <vue-editor v-model="assessment_intro" :editorToolbar="customToolbar" ref="textarea" placeholder="Enter Intro Text" @text-change="introTextChange"></vue-editor>
              </div>
              <div class="col-3 float-left override-padding">
                <div class="col-12 override-padding intro-text" @click="inclIntroText('{ User_First_Name }')">
                  { User_First_Name }
                </div>
                <div class="col-12 override-padding intro-text" style="margin-top: 10px;" @click="inclIntroText('{ Answer_Scale }')">
                  { Answer_Scale }
                </div>
                <div class="col-12 override-padding intro-text" style="margin-top: 10px;" @click="inclIntroText('{ Account_Name }')">
                  { Account_Name }
                </div>
                <div class="col-12 override-padding intro-text" style="margin-top: 10px;" @click="inclIntroText('{ Time_to_Complete }')">
                  { Time_to_Complete }
                </div>
                <div class="col-12 override-padding intro-text" style="margin-top: 10px;" @click="inclIntroText('{ #_of_Statements }')">
                  { #_of_Statements }
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 float-left no-section-display" v-if="(assessment_section_obj.sections.length == 0 && loading == false)">
            <div class="col-12 float-left text-heading">How to Create an Assessment</div>
            <div class="col-12 float-left text-text">1.) Click "Add Section"</div>
            <div class="col-12 float-left text-text">2.) Select an Existing Section to Add by clicking the check box to the left of section title OR Create an New Section</div>
            <div class="col-12 float-left text-text">3.) If creating a new section, once section is created you will see it avaliable for selection</div>
            <div class="col-12 float-left text-text">4.) Once section is selected via check box, click "Continue" to add the section to your assessment</div>
            <div class="col-12 float-left text-text">5.) Once added, you can add more sections, Save Assessment as a Draft, or Publish the assessment</div>
             <div class="col-12 float-left text-heading" style="font-size: 16px; padding-left: 25px;font-style:italic">NOTE: Once published, the assessment will be made available for assigned affiliates and user types.</div>
            <div class="col-lg-12 padding-lr-5 float-left text-align-center" style="padding-right: 0; padding-top: 20px;">
              <button
                v-on:click="addSectionClick()"
                class="btn btn-white col-2 override-padding" style="height: 40px; border-radius: 10px; font-weight: bold;"
                >Add Section</button>
            </div>
          </div>
          <div style="clear: both"></div>
          <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
          <div class="section-display" v-if="assessment_section_obj.sections.length > 0">
            <ul v-sortable="{onEnd: reorderSection, handle: '.handle1'}" class="counter_section-list list-group col-lg-12  override-padding margin-bottom-10">
              <li class="list-group-item input-height-25" v-for="(section, sindex) in assessment_section_obj.sections" :key="section.sortid">
                <div class="section_item float-left col-12 override-padding" >
                  <div class="col-12 override-padding float-left">
                    <div class="handle1 float-left col-lg-12 override-padding" style="padding-top: 2px;">
                      <div class="col-10 override-padding float-left">
                      <i class="fa fa-arrows padding-right-5" aria-hidden="true"></i>
                      <span style="font-weight: bold">
                      Section 
                      <span class="counter_section-list__counter"></span>
                      </span>
                      {{ section.title }} 
                      </div>
                      <div class="col-1 override-padding float-left">
                      <span style="font-weight: bold">
                      SCALE: 
                      </span>
                      {{ getScale(section.scale) }}
                      </div>
                      <div class="col-1 override-padding float-left">
                        <button
                          v-on:click="deleteSectionConfirm(sindex)"
                          class="btn btn-white col-12 padding-lr-5"
                          style="height: 30px;border-radius: 10px; margin-top: -2px;font-weight: bold;">Remove</button>
                      </div>
                      <div style="clear: both"></div>
                    </div>
                  </div>
                </div>
                <div class="counter_group-list col-12 override-padding">
                <div class="heading_item col-lg-11 float-right override-padding" v-for="(section_group, gindex) in section.group" :key="section_group.id">
                  <div class="handle2 float-left col-lg-12 override-padding collapse-wrapper float-right" style="padding-top: 2px;" v-if="section_group.questions.length > 0 && section_group.name != ''">
                    <b-link v-b-toggle="section.sortid + '-' + section_group.name" >
                      <div>
                        Group {{ section_group.name }} 
                        <i class="fa fa-angle-up" aria-hidden="true"></i>
                      </div>
                    </b-link>
                  </div>
                  <b-collapse v-bind:id="section.sortid + '-' + section_group.name" class="mt-2" visible v-if="section_group.questions.length > 0">
                  <div class="question_items">
                  <div class="question_item col-lg-12  float-left" v-for="(group_question, qindex) in section_group.questions" :key="group_question.id">
                    <div class="float-left col-lg-12 override-padding" style="padding-top: 2px;">
                      <span class="counter_group-list__counter"></span>
                      <span style="font-style:italic; font-size: 13px; padding-left: 7px; padding-right: 7px;" >{{ getStatus(group_question.type) }}</span>
                      {{ group_question.text }}
                    </div>
                  </div>
                  </div>
                  <div style="clear: both;margin-bottom: 10px"></div>
                  <div class="question_items" v-if="section_group.ranges.length > 0">
                  <div class="range_item col-12" >
                    <div class="heading-row">
                      <div class="col-1 float-left padding-lr-5 text-align-center">From</div>
                      <div class="col-1 float-left padding-lr-5 text-align-center">&nbsp;</div>
                      <div class="col-1 float-left padding-lr-5 text-align-center">To</div>
                      <div class="col-9 float-left padding-lr-5">Output Text</div>
                    </div>
                  </div>
                  <div class="range_item col-12" v-for="(group_range, rindex) in section_group.ranges" :key="group_range.id">
                      <div class="col-1 float-left padding-lr-5 text-align-center">{{ group_range.rangefrom }}</div>
                      <div class="col-1 float-left padding-lr-5 text-align-center">-</div>
                      <div class="col-1 float-left padding-lr-5 text-align-center">{{ group_range.rangeto }}</div>
                      <div class="col-9 float-left padding-lr-5"><span v-html="group_range.text"></span></div>
                  </div>
                  </div>
                  </b-collapse>


                </div>
                </div>
              </li>
            </ul>
            <div style="clear:both;margin-bottom: 10px;"></div>
            <div class="col-12 override-padding" v-if="assessment_output_range_flag == true">
              <div class="col-12 override-padding" style="border-bottom: 2px solid #CCC; margin-top: 15px;">
                <div class="heading-row" style="border: 0; padding-top: 10px;">
                  <div class="col-12 float-left override-padding">Assessment Details / Instructions
                    <label class="switch" style="margin-left: 10px;">
                      <input type="checkbox" v-model="toogle_switch" v-on:change="toogleChangeEvent()">
                      <span class="slider round"></span>
                    </label>

                  </div>


                </div>
                <div class="col-12 float-left override-padding assessment-details" style="margin-bottom: 10px; height: 150px;" v-if="toogle_switch == true">
                  <vue-editor v-model="assessment_details" :editorToolbar="customToolbar" placeholder="Enter Text..."></vue-editor>
                </div>
              </div>
              <div style="clear:both;margin-bottom: 0px;"></div>
              <div class="col-12 override-padding" style="border-top: 2px solid #CCC; margin-top: 0px;">
                <div class="add-statement-heading">
                  Enter Output Ranges and Text
                </div>
                <div style="clear:both;"></div>
                <div class="col-12 add-statement-heading override-padding" style="padding-top: 0;">
                  <div class="float-left" style="width: 13%;">
                    Minimum = <span class="rangetext">{{ assessment_min_range }}</span>
                  </div>
                  <div class="float-left" style="width: 13%;">
                    Maximum = <span class="rangetext">{{ assessment_max_range }}</span>
                  </div>
                  <div class="float-left" style="width: 13%;">
                    Range = <span class="rangetext">{{ assessment_range }}</span>
                  </div>
                  <div class="float-left rangetext" style="width: 13%;  font-style: italic;">
                    Quartile 4 = {{ parseInt(this.assessment_range * 0.25) }}
                  </div>
                  <div class="float-left rangetext" style="width: 13%; font-style: italic;">
                    Quartile 3 = {{ parseInt(this.assessment_range * 0.50) }}
                  </div>
                  <div class="float-left rangetext" style="width: 13%; font-style: italic;">
                    Quartile 2 = {{ parseInt(this.assessment_range * 0.75) }}
                  </div>
                  <div class="float-left rangetext" style="width: 13%; font-style: italic;">
                    Quartile 1 = {{ parseInt(this.assessment_range * 1) }}
                  </div>
                  <div style="clear:both;"></div>
                </div>
              </div>
              <div class="" v-for="(list, aindex) in assessment_output_range" :key="aindex">
                <div class="col-12 override-padding">
                  <div class="heading-row" style="border: 0;">
                    <div class="col-12 float-left override-padding">Output Range {{ parseInt(aindex+1) }} Title</div>
                  </div>
                  <div class="col-12 float-left override-padding" style="margin-bottom: 10px;">
                    <input
                      v-model="list.title"
                      class="col-lg-12 input-text form-control float-left padding-lr-5"
                      style="line-height: 30px;"
                      :placeholder="'Enter Output Range ' + parseInt(aindex+1) + ' Title'"
                      maxlength="250" />
                  </div>
                </div>

                <div class="col-12 override-padding">
                  <div class="heading-row" style="border: 0;">
                    <div class="col-1 float-left override-padding">From</div>
                    <div class="col-1 float-left override-padding text-align-center">>/<</div>
                    <div class="col-1 float-left override-padding">To</div>
                    <div class="col-9 float-left padding-lr-5">Output Text</div>
                  </div>
                </div>
                <div class="col-12 override-padding float-left" style="margin-top: 1px;">
                  <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;" >
                    <div class="col-1 float-left override-padding">
                      <input v-model="list.from"
                        v-on:blur="checkRangeNumbers(aindex, 'From')"
                        class="col-lg-12 input-text form-control float-left padding-lr-5"
                        style="line-height: 30px;"
                        maxlength="5" />
                    </div>
                    <div class="col-1 float-left override-padding text-align-center" style="margin-top: 5px;">
                      -
                    </div>
                    <div class="col-1 float-left override-padding">
                      <input v-model="list.to"
                        v-on:blur="checkRangeNumbers(aindex, 'To')"
                        class="col-lg-12 input-text form-control float-left padding-lr-5"
                        style="line-height: 30px;"
                        maxlength="5" />
                    </div>
                    <div class="col-8 float-left padding-lr-5 assessment-details" style="padding-right: 0; height: 150px;">
                      <vue-editor v-model="list.text" :editorToolbar="customToolbar" placeholder="Enter Text..."></vue-editor>
                    </div>
                    <div class="col-1 float-left delete-icon" style="font-weight: bold; margin-top: 5px;" v-if="assessment_output_range.length > 1">
                      <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="removeOutputRange(aindex)"></i>
                    </div>
                    <div style="clear: both;" ></div>
                  </div>
                </div>
                <div style="clear:both; margin-bottom: 0px;"></div>
              </div>
              <div class="col-12 override-padding">
                <div class="col-3 override-padding float-left">
                  &nbsp;
                </div>
                <div class="col-9 padding-lr-5 float-left add-on" v-on:click="addMoreOutputText()">
                  <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
                </div>
              </div>
              <div style="clear:both;"></div>

            </div>
          <div style="clear:both;margin-bottom: 10px;"></div>


            <div class="col-lg-2 padding-lr-5 float-right text-align-right" style="padding-right: 0;">
              <button
                @click="onSubmit"
                class="btn btn-red col-10 padding-lr-5"
                style="height: 30px;border-radius: 10px; margin-top: 2px;font-weight: bold;">Save and Exit</button>
            </div>
            <div class="col-lg-2 padding-lr-5 float-right text-align-right" style="padding-right: 0;">
              <button
                @click="onPreview"
                class="btn btn-white col-8 padding-lr-5"
                style="height: 30px;border-radius: 10px; margin-top: 2px;font-weight: bold;">Preview</button>
            </div>
            <div class="col-lg-2 padding-lr-5 float-right text-align-right">
              <button
                v-on:click="addSectionClick()"
                class="btn btn-white col-8 override-padding" style="margin-top: 2px; height: 30px; border-radius: 10px; font-weight: bold;"
                >Add Section</button>
            </div>
            <div style="clear: both; margin-bottom: 25px;"></div>
          </div>
        </div>
        </div>


    </div>

    <EditAssessmentModal :isModalVisible="isEditModalVisible" @close="isEditModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Edit Assessment</h3></div>
      <div slot="body">
        <div class="col-12 override-padding">
          <input v-model="assessment_title"
                name="assessment_title"
                placeholder="Enter Assessment Title..."
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required'"
                maxlength="255" />
          <div v-if="verrors.firstByRule('assessment_title', 'required')" class="margin-bottom-5 validate-warning-msg">Assessment Title is required</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <div class="col-12 override-padding">
          <div class="search-padd" id="mentee-group-wrapper">
          <multiselect
            v-model="affiliate_selected"
            :options="affiliate_options" track-by="name" label="name"
            placeholder="Select Affiliates..." :multiple="true"  :close-on-select="false" :show-labels="false"
            v-validate="'required'"
            name="affiliate"
            id="affiliate"
            >
            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
          </multiselect>
          <div v-if="verrors.firstByRule('affiliate', 'required')" class="margin-bottom-5 validate-warning-msg">Affilates is required</div>
         </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
 
        <div class="col-12 override-padding">
          <div class="search-padd" id="mentee-group-wrapper">
          <multiselect
            v-model="roles_selected"
            :options="roles_options"
            track-by="name" label="name"
            placeholder="Select Users..."
            :multiple="true" 
            :close-on-select="false"
            :show-labels="false"
            v-validate="'required'"
            name="roles"
            id="roles"
            >
            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
      

          </multiselect>
          <div v-if="verrors.firstByRule('roles', 'required')" class="margin-bottom-5 validate-warning-msg">Users is required</div>
  
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <div class="col-12 override-padding text-align-right">
          <button
              v-on:click="editAssessment()"
              class="btn btn-red col-lg-3"
              style="line-height: 30px; border-radius: 10px;"
              ><b>Update</b></button>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </EditAssessmentModal>

    <DeleteModal :isModalVisible="isModalVisible" :id="id" :parent_id="parent_id" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">{{ deleteMessage }}</div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
        <button class="left col-12 btn btn-red" @click="isModalVisible = false; deleteAction()">Confirm</button>
      </div>
    </DeleteModal>



  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import Sortable from 'sortablejs';
import DeleteModal from '../shared/delete_modal_alert.vue';
import Multiselect from 'vue-multiselect';
import EditAssessmentModal from '../admin/create-tasklist-modal.vue';
import { VueEditor } from "vue2-editor";

Vue.directive('sortable', {
  inserted: function (el, binding) {
    var sortable = new Sortable(el, binding.value || {});
  }
});


export default {
        data() {
          return {
            assessment_section_obj: {
              assessment: [],
              sections: [],
              section_sort_flag: false,
              remove_sections: [],
            },
            loading: false,
            assessment_id: '',
            type_options: [
              { value: '', text: 'Select' },
              { value: 'Global', text: 'GLO' },
              { value: 'Intuitive', text: 'INT' },
              { value: 'Individual', text: 'IND' },
              { value: 'Negative', text: 'NEG' },
            ],
            scale_options: [
              { value: '', text: 'Select Scale' },
              { value: '1', text: '1-3' },
              { value: '2', text: '1-5' },
              { value: '3', text: '1-7' },
            ],
            sectionIndexValue: '',
            deleteMessage: '',
            isModalVisible: false,
            id: '',
            parent_id: '',
            affiliate_options: [],
            assessment_title: '',
            index: 1,
            roles_options: [
              {
                name: 'Admin',
                value: 'ROLE_ADMIN',
              },
              {
                name: 'Mentor',
                value: 'ROLE_MENTOR',
              },
              {
                name: 'Mentee',
                value: 'ROLE_MENTEE',
              },
              {
                name: 'Apprentice',
                value: 'ROLE_APPRENTICE',
              },
              {
                name: 'Instructor',
                value: 'ROLE_INSTRUCTOR',
              },
              {
                name: 'Student',
                value: 'ROLE_STUDENT',
              },
            ],
            affiliate_selected: [],
            roles_selected: [],
            isEditModalVisible: false,
            assessment_min_range: 0,
            assessment_max_range: 0,
            assessment_range: 0,
            assessment_output_range: [
              {
                from: '',
                to: '',
                text: '',
                title: '',
              }
            ],
            assessment_details: '',
            customToolbar:[[{ list: "bullet" }, "bold", "italic", "underline"]],
            assessment_output_range_flag: false,
            toogle_switch: true,
            assessment_intro: '',
          }

        },

        components: {
          UserMenu,
          GoBack,
          MasteradminSidebarMenu,
          DeleteModal,
          Multiselect,
          EditAssessmentModal,
          VueEditor
        },
        methods: {
          closeModal() {
            this.$emit('close');
          },
          introTextChange: function() {
            var limit = 1250;
            var quill = this.$refs.textarea.quill;

            quill.on('text-change', function (delta, old, source) {
             if (quill.getLength() > limit) {
              quill.deleteText(limit, quill.getLength());
             }
            });
          },
          inclIntroText: function(arg) {
            let quill = this.$refs.textarea.quill;
            let pos = quill.selection.savedRange.index;
            
            const insertText = arg;

            if (pos === undefined) {
              pos = 0
            }
            quill.insertText(pos, insertText);

          },
          removeOutputRange: function(index) {
            this.assessment_output_range.splice(index, 1);
          },
          addMoreOutputText: function() {
            if(this.assessment_output_range.length >= 25) {
              alert("You can't add more than 25 Output Ranges");
              return false;
            }
            this.assessment_output_range.push({
              from: '',
              to: '',
              text: '',
              title: '',
            });
          },
          toogleChangeEvent: function() {
            if(this.toogle_switch == false) {
              this.assessment_details = '';
            }
          },
          isNumeric(value){
            var regex = /^[0-9]*$/
            return regex.test(value);
          },
          checkRangeNumbers: function(index, arg) {
            if(!this.isNumeric(this.assessment_output_range[index].from)) {
              this.assessment_output_range[index].from = '';
              return false;
            }
            if(!this.isNumeric(this.assessment_output_range[index].to)) {
              this.assessment_output_range[index].to = '';
              return false;
            }
            var minRange = this.assessment_min_range;
            var maxRange = this.assessment_max_range;
            if((index == 0) && (arg == 'From')) {
              if(parseInt(this.assessment_output_range[index].from) != parseInt(minRange)) {
                alert("From range should be equal to the minimum range");
                this.assessment_output_range[index].from = '';
                return false;
              }
            }
            if((index > 0) && (arg == 'From')) {
              var preIndex = parseInt(index-1);
              if(parseInt(this.assessment_output_range[index].from) <= parseInt(this.assessment_output_range[preIndex].to)) {
                alert("From range should be higher than the previous To range");
                this.assessment_output_range[index].from = '';
                return false;
              }
            }
            if((parseInt(index+1) == this.assessment_output_range.length) && (arg == 'To')) {
              if(parseInt(this.assessment_output_range[index].to) > parseInt(maxRange)) {
                alert("To range should be lesser or equal to the maximum range");
                this.assessment_output_range[index].to = '';
                return false;
              }
              else {
                if(parseInt(this.assessment_output_range[index].from) > parseInt(this.assessment_output_range[index].to)) {
                  alert("To range should be higher than the From range");
                  this.assessment_output_range[index].to = '';
                  return false;
                }
              }
            }
            if((parseInt(index+1) < this.assessment_output_range.length) && (arg == 'To')) {
              if(parseInt(this.assessment_output_range[index].from) > parseInt(this.assessment_output_range[index].to)) {
                alert("To range should be higher than the From range");
                this.assessment_output_range[index].to = '';
                return false;
              }
            }
          },
           editAssessment: function() {
            this.$validator.validateAll().then((result) => {
              if ((this.verrors.items.length === 0)) {
                  axios('/assessment-builder/' + this.assessment_id,
                     {
                       method: 'PATCH',
                       data:
                        {
                          title: this.assessment_title,
                          affiliate_selected: this.affiliate_selected,
                          roles_selected: this.roles_selected,
                        },
                     }
                   )
                  .then((resp) => {
                      this.$emit('close');
                      this.isEditModalVisible = false;
                      this.fetchSectionLists();
                   })
                  .catch(error => {
                    if(error.response.data.message == 'Access denied.') {
                      router.push("/forbidden");
                    }
                  });

              }
            });
           },
          doValidate: function() {
            var vflag = 1;
            if(!this.assessment_intro) {
              alert("Please enter Assessment Introduction / Landing Page");
              vflag = 0;
              return false;
            }
            if(this.assessment_output_range_flag == true) {
              if(this.toogle_switch == true) {
                if(this.assessment_details == '') {
                  alert("Please enter Assessment Details/Instructions");
                  vflag = 0;
                  return false;
                }
              }
              var aaflag = 0;
              for(var i=0; i<this.assessment_output_range.length; i++) {
                if(this.assessment_output_range[i].from != '') {
                  aaflag = 1;
                }
              }
              if((aaflag == 0) && (this.assessment_section_obj.assessment.status == 'PUBLISH')) {
                alert("Please enter atleast one Output Range");
                vflag = 0;
                return false;
              }
              if(this.assessment_output_range[0].from > 0) {

                var minRange = this.assessment_min_range;
                var maxRange = this.assessment_max_range;
                var last_to_range = '';var j;
                for(var i=this.assessment_output_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.assessment_output_range[j].from != '') && (this.assessment_output_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  


                if(last_to_range > -1) {
                  if(this.assessment_output_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.assessment_output_range[last_to_range].to = '';
                    return false;
                  }
                } 
                for(var i=0; i<this.assessment_output_range.length; i++) {

                  if((i == 0)) {
                    if(this.assessment_output_range[i].from != minRange) {
                      alert("First From range should be equal to minimum range");
                      vflag = 0;
                      this.assessment_output_range[i].from = '';
                      return false;
                    }
                  }

                  if((this.assessment_output_range[i].from != '') && ((this.assessment_output_range[i].to == '') || (this.assessment_output_range[i].text == '') || (this.assessment_output_range[i].title == ''))) {
                    if(this.assessment_output_range[i].title == '') {
                      alert("Range title should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.assessment_output_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.assessment_output_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.assessment_output_range[i].to != '') && ((this.assessment_output_range[i].from == '') || (this.assessment_output_range[i].text == '') || (this.assessment_output_range[i].title == ''))) {
                    if(this.assessment_output_range[i].title == '') {
                      alert("Range title should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.assessment_output_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.assessment_output_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.assessment_output_range[i].text != '') && ((this.assessment_output_range[i].from == '') || (this.assessment_output_range[i].to == '') || (this.assessment_output_range[i].title == ''))) {
                    if(this.assessment_output_range[i].title == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.assessment_output_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.assessment_output_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.assessment_output_range[i].title != '') && ((this.assessment_output_range[i].from == '') || (this.assessment_output_range[i].to == '') || (this.assessment_output_range[i].text == ''))) {
                    if(this.assessment_output_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.assessment_output_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.assessment_output_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }
              }
            }
            return vflag;
          },
          onPreview: function() {
            var vflag = this.doValidate();
            if(vflag == 1) {
              axios('/assessment-section-lists',
                 {
                   method: 'POST',
                   data: {
                      "assessment_section_obj": this.assessment_section_obj,
                      "assessment_output_range": this.assessment_output_range,
                      "assessment_details": this.assessment_details,
                      "toogle_switch": this.toogle_switch,
                      "assessment_intro": this.assessment_intro,
                   },
                 })
              .then((resp) => {
                axios('/desktop/user-assessment-attempts/' + this.assessment_id + '/NULL',
                {
                  method: 'POST',
                })
                .then((resp) => {
                  router.push('/assessment-landing-page/' + this.assessment_id + '/' + resp.data);
                })
                .catch(() => {

                });

               })
              .catch(error => {

                });
            }
          },
          onSubmit: function() {
            var vflag = this.doValidate();
            if(vflag == 1) {
              axios('/assessment-section-lists',
                 {
                   method: 'POST',
                   data: {
                      "assessment_section_obj": this.assessment_section_obj,
                      "assessment_output_range": this.assessment_output_range,
                      "assessment_details": this.assessment_details,
                      "toogle_switch": this.toogle_switch,
                      "assessment_intro": this.assessment_intro,
                   },
                 })
              .then((resp) => {
                  this.$store.dispatch('assessment_sections', '');
                  router.push("/assessment-builder-list");

               })
              .catch(error => {

              });
            }

          },
          addSectionClick: function() {
            this.$store.dispatch('assessment_sections', this.assessment_section_obj);
            router.push("/choose-assessment-section/" + this.assessment_id);
          },
          deleteAction: function() {
            var remove_data = this.assessment_section_obj.sections[this.sectionIndexValue];
            if(remove_data.update == true) {
              this.assessment_section_obj.remove_sections.push({
                section_id: remove_data.id,
              });
              this.assessment_section_obj.sections.splice(this.sectionIndexValue, 1);
            }
            else {
              this.assessment_section_obj.sections.splice(this.sectionIndexValue, 1);
            }
            var j=1;
            for(var i=0; i < this.assessment_section_obj.sections.length; i++) {
              this.assessment_section_obj.sections[i].sortid = 'section-' + j;
              j++;
            }
            this.getMinMaxAssessment();
            this.$store.dispatch('assessment_sections', this.assessment_section_obj);
          },

          getStatus: function(val) {
            var type_val = this.type_options.findIndex(item => item.value == val);
            return this.type_options[type_val].text;
          },
          getScale: function(scale) {
            var scale_val = this.scale_options.findIndex(item => item.value == scale);
            return this.scale_options[scale_val].text;
          },

          reorderSection ({oldIndex, newIndex}) {
            const movedItem = this.assessment_section_obj.sections.splice(oldIndex, 1)[0];
            this.assessment_section_obj.sections.splice(newIndex, 0, movedItem);
            this.assessment_section_obj.section_sort_flag = true;
            this.$store.dispatch('assessment_sections', this.assessment_section_obj);
          },
          deleteSectionConfirm: function(index) {
            this.deleteMessage = 'Are you sure you want to delete?';
            this.sectionIndexValue = index;
            this.isModalVisible = true;
          },
          getMinMaxAssessment: function() {
            this.assessment_max_range = 0;
            this.assessment_min_range = 0;
            this.assessment_output_range_flag = false;
            for(var i=0; i < this.assessment_section_obj.sections.length; i++) {
              this.assessment_min_range =  parseInt(this.assessment_section_obj.sections[i].minrange + this.assessment_min_range);
              this.assessment_max_range =  parseInt(this.assessment_section_obj.sections[i].maxrange + this.assessment_max_range);
              if(this.assessment_section_obj.sections[i].type == 'no-output') {
                this.assessment_output_range_flag = true;
              }
            }
            this.assessment_range = parseInt(this.assessment_max_range - this.assessment_min_range);
            if((this.assessment_output_range.length > 0) && (this.assessment_output_range_flag == false)) {
              this.assessment_output_range = [{
                from: '',
                to: '',
                text: '',
                title: '',
              }];
              this.assessment_details = '';
            }
          },
          fetchSectionLists: function() {
            this.loading = true;
            axios.get('/assessment-section-mapping-lists/' + this.assessment_id)
              .then((resp) => {
                  this.loading = false;
                  this.assessment_section_obj.assessment = resp.data.assessment;
                  this.roles_selected = resp.data.assessment.roles_assigned;
                  this.affiliate_selected = resp.data.assessment.affiliate_assigned;
                  this.assessment_title = resp.data.assessment.name;
                  this.assessment_section_obj.sections = resp.data.sections;
                  this.getMinMaxAssessment();
                  this.assessment_section_obj.section_sort_flag = false;
                  this.assessment_section_obj.remove_sections = [];
                  this.assessment_details = resp.data.assessment.assessment_details;
                  this.assessment_intro = resp.data.assessment.assessment_intro;
                  this.toogle_switch = resp.data.assessment.toogle_switch;
                  this.assessment_output_range = resp.data.assessment.range;
                  if(this.assessment_output_range.length == 0) {
                    this.assessment_output_range.push({
                      from: '',
                      to: '',
                      text: '',
                      title: '',
                    });
                  }
                  this.$store.dispatch('assessment_sections', this.assessment_section_obj);
              })
              .catch(error => {

              });

          },
           fetchAffiliateOptions: function() {
             axios.get('/affiliateoptions', {

             })
             .then((response) => {
                 for(var i=0; i < response.data.length; i++) {
                   var affiliate_option = {value: response.data[i].id, name: response.data[i].name};
                   this.affiliate_options.push(affiliate_option);
                 }
             })
             .catch(error => {

             });

           },

        },
         created() {
            this.loading = true;
            this.assessment_id = this.$route.params.assessment_id;
           if((store.state.page_url) && (store.state.page_url === 'Tasklists')) {
             this.selectedComponent = store.state.active_tab;
           }
           var roles = store.state.roles;
           if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
             this.masterAdmin = true;
           }
          if((!this.$store.state.assessment_section_obj.assessment) && (!this.$store.state.assessment_section_obj.sections)) {
            this.fetchSectionLists();
          }
          else {
            this.loading = false;
            this.assessment_section_obj = this.$store.state.assessment_section_obj;
            this.roles_selected = this.$store.state.assessment_section_obj.assessment.roles_assigned;
            this.affiliate_selected = this.$store.state.assessment_section_obj.assessment.affiliate_assigned;
            this.assessment_output_range = this.$store.state.assessment_section_obj.assessment.range;
            this.assessment_details = this.$store.state.assessment_section_obj.assessment.assessment_details;
            this.assessment_intro = this.$store.state.assessment_section_obj.assessment.assessment_intro;
            this.toogle_switch = this.$store.state.assessment_section_obj.assessment.toogle_switch;
            this.assessment_title = this.$store.state.assessment_section_obj.assessment.name;
            setTimeout(() => {
              this.getMinMaxAssessment();
            }, 1000);
          }
          this.fetchAffiliateOptions();
          }
    }
</script>

<style scoped>
.list-group-item {
  background: none;
  border: 0;
  padding: 0;
}
.section_item {
    background: #AFAFAF;
    padding: 5px 15px;
    margin-bottom: 0px;
}
.collapse-wrapper {
  background-color: #D3D3D3;
  border: 1px solid #D0D0D0;
  font-weight: bold;
  padding: 5px 10px;
  margin-top: 2px;
}
.collapse-wrapper a, .collapse-wrapper a:hover{ 
  color: #000;
  text-decoration: none;
}
.collapse-wrapper i {
  float: right;
  font-size: 18px;
  font-weight: bold;
  padding-top: 5px;
  color: #A6A6A6;
}
.question_item {
  background-color: #FFF;
}
.heading-row {
  font-weight: bold;
  color: #000;
  padding-bottom: 5px;
  border-bottom: 2px solid #CCC;
  width: 100%;
  float: left;
  padding-top: 5px;
}
.range_item {
  background-color: #FFF;
  float: left;
}
.question_items {
  padding-top: 5px;
  padding-bottom: 5px;
  width: 100%;
  float: left;
  background-color: #FFF;
}
.counter_section-list {
  counter-reset: my-sec-counter;
}
.counter_section-list__counter:after {
  counter-increment: my-sec-counter;
  content: counter(my-sec-counter) ": ";
}
.counter_group-list {
  counter-reset: my-sec-counter2;
}
.counter_group-list__counter:after {
  counter-increment: my-sec-counter2;
  content: counter(my-sec-counter2) ". ";
}
.assessment-edit-icon {
  padding-left: 10px;
  font-size: 20px;
}
.no-section-display {
  padding-top: 50px;
  padding-left: 0px;
}
.text-heading {
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 18px;
  padding-left: 0;
}
.text-text {
  font-size: 16px;
  padding-bottom: 18px;
  padding-left: 0;
}
.intro-text {
  background-color: #FFF; 
  border: 1px solid #FFF;
  border-radius: 10px;
  padding: 5px 10px 5px 10px;
  text-align: center;
  color: #828282;
  cursor: pointer;
}

</style>
<style>
.input-height-30 {
  line-height: 28px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected span::before,
#mentee-group-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected.multiselect__option--highlight,
#mentee-group-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: #fff !important;
}
.assessment-details .ql-editor { height: 120px !important; min-height: 120px !important; overflow-y: scroll !important; }
.assessment-intro  .ql-editor { height: 190px !important; min-height: 205px !important; overflow-y: scroll !important; }

.assessment-add-section .quillWrapper { background-color: #FFF;  }
.add-on {
  font-weight: normal;
  font-size: 12px;
  color: #8D8D8D !important;
  cursor: pointer;
  text-align: right;
}
.assessment-add-section .quillWrapper .ql-container.ql-snow {
  border: 1px solid #ccc !important;
}
.assessment-details .quillWrapper .ql-snow.ql-toolbar {
  position: absolute;
  top: 120px;
  height: 40px;
  padding-left: 0;
  border: 0;
}
.assessment-intro .quillWrapper .ql-snow.ql-toolbar {
  position: absolute;
  top: 205px;
  height: 40px;
  padding-left: 0;
  border: 0;
}
.assessment-add-section .quillWrapper .ql-formats button {
  padding-left: 0 !important;
  width: 22px !important;
}
.assessment-add-section .quillWrapper .ql-formats button svg {
  width: 18px !important;
  height: 18px !importa.nt;
}
.add-statement-heading {
  font-weight: bold;
  color: #000;
  font-size: 14px !important;
  padding: 10px 0 10px 0;
}
.rangetext {
  font-weight: normal;
  font-size: 13px;
}
.delete-icon {
  color: #FF0000;
}
.mt-2 {
  margin-top: 0 !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  background-color: #FFF;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 2px;
  background-color: #CCC;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #FFF;
}
input:checked + .slider:before {
  background-color: #83E517;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/admin/assessment_add_section.vue